import { useState } from 'react'
import { Modal, Grid } from '@mui/material'
import { IProductFeatureModalProps } from './productfeaturemodal.types'
import CustomButton from 'components/Button/CustomButton'
import { Add } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

const ProductFeatureModal = ({
  featureModalData,
  controlButtonTexts,
  featureModalLink,
  localKey,
  isBannerMode = false,
  popupOpen,
  setPopupOpen
}: IProductFeatureModalProps) => {
  const isFeatureModalDismissed = localStorage.getItem(localKey) ? true : false
  const [featureInfoModalOpen, setFeatureInfoModalOpen] = useState<boolean>(
    isBannerMode ? !!popupOpen : !isFeatureModalDismissed
  )
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)
  const navigate = useNavigate()

  const handlePrevClick = () => {
    setCurrentSlideIndex((prevIndex: number) => Math.max(prevIndex - 1, 0))
  }

  const handleNextClick = () => {
    setCurrentSlideIndex((prevIndex: number) =>
      Math.min(prevIndex + 1, featureModalData.length - 1)
    )
  }

  const handleFeatureModalClose = () => {
    localStorage.setItem(localKey, 'true')
    if (isBannerMode && setPopupOpen) {
      setPopupOpen(false)
    }
    setFeatureInfoModalOpen(false)
  }

  const handleNavigate = (url: string) => {
    featureModalData[currentSlideIndex].isExternalLink
      ? window.open(url, '_blank')
      : navigate(`${url}`)
    handleFeatureModalClose()
  }

  return (
    <Modal
      open={featureInfoModalOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(38, 40, 44, 0.7)',
          backdropFilter: 'blur(5px)'
        }
      }}
    >
      <div className="modal-container modalcontainer--large">
        <div>
          <div className="flex justify-between mr-[-28px]">
            <button
              className="flex justify-end items-end w-full cursor-pointer"
              onClick={handleFeatureModalClose}
            >
              <Add
                style={{
                  transform: `rotate(45deg)`,
                  color: '#ffffff',
                  fontSize: '30px'
                }}
              />
            </button>
          </div>
          <div className="overflow-auto pb-4 max-h-[84dvh] bg-black rounded-lg ripper-skippers-moments">
            {featureModalData[currentSlideIndex].image && (
              <div className="mb-4">
                <img
                  src={featureModalData[currentSlideIndex].image}
                  className="align-top"
                  alt={featureModalData[currentSlideIndex].heading}
                />
              </div>
            )}
            {featureModalData[currentSlideIndex].tag && (
              <div className="pb-2 text-lg font-bold text-blue3">
                {featureModalData[currentSlideIndex].tag}
              </div>
            )}
            <div className="pb-1 text-[22px] font-bold">
              {featureModalData[currentSlideIndex].heading}
            </div>
            <div className="pb-6">
              {featureModalData[currentSlideIndex].body}
            </div>
            <Grid
              item
              className={`flex flex-row gap-x-3 items-center w-full pb-4 ${
                currentSlideIndex !== 0 ? 'justify-between' : 'justify-end'
              }`}
            >
              {currentSlideIndex !== 0 && (
                <CustomButton
                  type="button"
                  model="secondary"
                  variant="contained"
                  label={controlButtonTexts.prev}
                  onClick={() => handlePrevClick()}
                />
              )}
              {currentSlideIndex === featureModalData.length - 1 ? (
                <CustomButton
                  type="button"
                  model="primary"
                  variant="contained"
                  label={controlButtonTexts.end}
                  onClick={() => handleNavigate(featureModalLink)}
                />
              ) : (
                <CustomButton
                  type="button"
                  model="primary"
                  variant="contained"
                  label={controlButtonTexts.next}
                  onClick={() => handleNextClick()}
                />
              )}
            </Grid>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ProductFeatureModal
